module.exports = __webpack_public_path__ + "img/kfma.94345b48.jpg";